import { userType } from "../../DTO";
import { Api } from "../api";

export const UpdateRegisterState = (
    user: userType,
    userID: string | number,
    registerState: string,
) => {
    return new Promise<{ data: any }>((resolve, reject) => {
        const api = new Api({
            method: "patch",
            path: `users/${userID}/register-state`,
            header: {
                Authorization: "Bearer " + user?.access_token,
            },
            body: {
                register_state: registerState,
            },
        });
        return api
            .call()
            .then((data: any) => {
                return resolve({ data: data.data });
            })
            .catch((err: any) => {
                return reject(err);
            });
    });
};
